import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const RichTitle = ({ parts, className = "" }) => (
  <h2 className={`font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mt-5 leading-[1.05] ${className}`}>
    {parts.map(([text, style], i) => (
      <span key={i} className={style === "gold" ? "text-gold" : style === "outline" ? "text-outline-gold" : ""}>
        {text}
      </span>
    ))}
  </h2>
);

export const SectionHead = ({ tag, title, sub, align = "center" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-gold flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
        <span className="h-px w-8 bg-gold/60 inline-block" />
        {tag}
        <span className="h-px w-8 bg-gold/60 inline-block" />
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <RichTitle parts={title} />
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="text-slate-400 text-base sm:text-lg leading-relaxed mt-5">{sub}</p>
      </Reveal>
    )}
  </div>
);
